import React from 'react';
import { SectionCard, SectionTitle, SectionText, StyledCollapse } from './styles';
import { ShiftDetailsSectionProps } from './types';

const { Panel } = StyledCollapse;

const ShiftDetailsSection: React.FC<ShiftDetailsSectionProps> = ({ shiftDetails, isOpen }) => {
  return (
    <StyledCollapse activeKey={isOpen ? ['shiftDetails'] : []} ghost expandIcon={() => null}>
      <Panel key="shiftDetails" header={null}>
        <SectionCard>
          <SectionTitle level={4}>Shift Details</SectionTitle>
          <SectionText>
            Shift Time: {shiftDetails.start_time} - {shiftDetails.end_time}
          </SectionText>
          <SectionText>Assigned Section: {shiftDetails.section}</SectionText>
          <SectionText>Today&apos;s Specials: {shiftDetails.specials}</SectionText>
        </SectionCard>
      </Panel>
    </StyledCollapse>
  );
};

export default ShiftDetailsSection;
